import { II18n } from '../../../../models';
import { I18nService } from '../../../../services';
import React from 'react';

const translations: II18n = {
  es: {
    title: 'Banderas de enlace',
  },
  enUS: {
    title: 'Link flags',
  },
  ptBR: {
    title: 'Vincular flags',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

export { translate };
